import styled from "styled-components";

export const Container = styled.div`
text-align: center;
display: flex;
flex-direction: column;
align-items:center;
gap: 20px;
`